import CaretSmallIcon from 'components/icons/CaretSmallIcon';
import UILink from 'components/ui/UILink';

type SectionNavigationProps = {
  current: number;
  onContinue: () => void;
  goBack: () => void;
  goForward: () => void;
};

const SectionNavigation = ({
  current,
  onContinue,
  goBack,
  goForward,
}: SectionNavigationProps) => {
  const isOnFirstPage = current === 0;
  const isOnLastPage = current === 3;

  return (
    <>
      <nav className="bottom-nav">
        <button
          className="button secondary back-btn"
          onClick={goBack}
          disabled={isOnFirstPage}
        >
          <CaretSmallIcon
            direction="left"
            color={isOnFirstPage ? 'gray' : 'purple'}
          />
          <span>Back</span>
        </button>
        <button
          className="button secondary next-btn"
          onClick={goForward}
          disabled={isOnLastPage}
        >
          <span>Next</span>
          <CaretSmallIcon
            direction="right"
            color={isOnLastPage ? 'gray' : 'purple'}
          />
        </button>
      </nav>
      {isOnLastPage && (
        <p className="footnote">
          Once you&apos;re done, return to&nbsp;
          <UILink
            textType="subhead"
            size="medium"
            label="get your recommendation with ALEX!"
            onClick={onContinue}
          />
        </p>
      )}
    </>
  );
};

export default SectionNavigation;
